<script>
  import { AmbientLight } from 'three'
  import { renderable } from './three-viz.js'

  export let color

  renderable({
    setup: props => {
      const { scene } = props

      scene.add(new AmbientLight(color))
    },
  })
</script>
